import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import HousingDetailItem2 from './HousingDetailItem2';
import {
  housingSavingsDetailInputList3,
  ntsTypeOptions,
  savingCategoryOptions,
} from '../../../../common/data';

import Button from '../../../../components/common/Button';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import {
  getHousingFundsDataDetail,
  resetDetailData,
  saveHousingFunds,
  saveHousingFunds2,
} from '../housingFundsSlice';
import { getBankList, setIsDataModified } from '../../../common/commonSlice';
import {
  getAlertMessageFunction,
  getDeleteDialogConfig,
  handleNumberChange2,
  magamCertifyCheck,
} from '../../../../common/Util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { isValidate } from '../util';

//주택 마련 저축
const Type3 = ({ onClose, isOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const inputList = housingSavingsDetailInputList3(t);
  const ntsTypeList = ntsTypeOptions(tCommon);
  const savingCategoryList = savingCategoryOptions(t);
  const { detailDataList, detailReload } = useSelector(state => state.housingFunds);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const { bankList } = useSelector(state => state.common);
  const [dataList, setDataList] = useState([
    {
      htm001: '',
      htm002: '',
      htm003: '',
      htm004: '',
    },
  ]);

  useEffect(() => {
    if (isOpen) {
      dispatch(getHousingFundsDataDetail({ hInType: '3' }));
    }
    if (bankList.length === 0) {
      dispatch(getBankList());
    }

    return () => {
      dispatch(resetDetailData());
    };
  }, [detailReload, isOpen]);

  useEffect(() => {
    if (detailDataList) {
      const formattedData = detailDataList.map(item => ({
        htmFlag: item.htmFlag || '',
        htmKFlag: item.htmKFlag || '2',
        htmPDFFlag: item.htmPDFFlag || '',
        htmType: item.htmType || '',
        htmSeq: item.htmSeq || '',
        htm001: item.htm001 || '',
        htm002: item.htm002 || '',
        htm003: item.htm003 || '',
        htm004: item.htm004 || '',
      }));

      console.log('formattedData', formattedData);
      setDataList(formattedData);
    }
  }, [detailDataList]);

  const handleChange = (e, dataIndex) => {
    let { name, value } = e.target;

    if (name === 'htm004') {
      value = handleNumberChange2(value);
    }
    console.log(name, value);
    console.log('dataIndex', dataIndex);

    dispatch(setIsDataModified(true));

    setDataList(prev => {
      const newData = [...prev];
      newData[dataIndex][name] = value;
      return newData;
    });
  };

  const handleAddButton = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    setDataList(prev => {
      const newData = [...prev];
      newData.push({
        htmFlag: 'B',
        htmKFlag: '2',
        htmSeq: '',
        htm001: '',
        htm002: '',
        htm003: '',
        htm004: '',
      });
      return newData;
    });
  };

  const handleDeleteButton = dataIndex => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    let apiDelete = false;
    dataList[dataIndex].htmSeq != '' ? (apiDelete = true) : (apiDelete = false);

    if (apiDelete) {
      let formData = {
        htmFlag: dataList[dataIndex].htmFlag,
        htmSeq: dataList[dataIndex].htmSeq,
      };

      dispatch(getDeleteDialogConfig(tCommon, 'housingFunds', formData));

      return;
    }

    setDataList(prev => {
      const newData = [...prev];
      newData.splice(dataIndex, 1);
      return newData;
    });
  };

  const codeList = (key, pdfFlag) => {
    let list = [];
    if (key === 'htm001') {
      list = savingCategoryList;
    } else if (key === 'htmKFlag') {
      if (pdfFlag) {
        list = ntsTypeList.filter(item => item.value !== '1');
      } else {
        list = ntsTypeList;
      }
    } else if (key === 'htm002') {
      list = bankList;
      return list.map((item, index) => {
        return (
          <option key={index} value={item.bankCd?.trim()}>
            {item.bankNm}
          </option>
        );
      });
    }
    return list.map((item, index) => {
      return (
        <option key={index} value={item.value}>
          {item.label}
        </option>
      );
    });
  };

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();
    console.log('isValidate(dataList, t)', isValidate(dataList, t));
    if (!isValidate(dataList, t)) {
      console.log('1');
      return;
    }

    try {
      const response = await dispatch(saveHousingFunds2({ formData: [...dataList] })).unwrap();
      if (response.resultCode === 'OK') {
        alertMessage(tCommon('alertMessage.saveSuccess'), 'success');
        onClose();
      } else {
        alertMessage(tCommon('alertMessage.saveFail'), 'error');
      }
    } catch (error) {
      console.log(error);
      alertMessage(tCommon('alertMessage.saveFail'), 'error');
    }
  };

  return (
    <SlideRightDialog onClose={onClose} isOpen={isOpen}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.title3')}`} />
        {dataList?.map((data, dataIndex) => {
          let disabled = data.htmType == '1' && data.htmPDFFlag == '2' && data.htmKFlag == '1';
          return (
            <HousingDetailItem2
              key={dataIndex}
              {...{
                inputList,
                dataList,
                data,
                handleChange,
                handleAddButton,
                handleDeleteButton,
                dataIndex,
                codeList,
                title: `${t('detail.title3')}`,
                disabled,
              }}
            />
          );
        })}
        <Button
          value={t('detail.addButton')}
          style={{ width: '100%' }}
          addButton
          color="sub"
          onClick={handleAddButton}
        />
        {/* 취소,저장버튼 */}
        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default Type3;
